import {Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {IconsService} from "@amlCore/services";
import {FileSaverService} from "ngx-filesaver";
import {HttpParams} from '@angular/common/http';
import moment from "moment";
import {of} from "rxjs";
import {catchError, tap} from "rxjs/operators";
import {InputFileComponent} from "../../../core";

/**
 * Компонент импорта
 */
@Component({
    selector: 'app-import-document',
    templateUrl: './import-documents.component.html',
    styleUrls: ['./import-documents.component.scss']
})
export class ImportDocumentsComponent implements OnInit, OnDestroy {
    @Input() url = '/api/v1/documents/import';
    @Input() typeFileToImport = 'ФЭС';
    @Input() nominativeTypeFileToImport = 'ФЭС';
    @Input() maxSizeFile = 134217728;

    @ViewChild('inputFile') inputFile: InputFileComponent;

    loading = false;
    accept = '.xml';
    importedData: [] = [];
    importPercent = 0;
    icons = this._iconsService.getIcons();
    overSizeFilesArr: any = [];
    upploadingFiles = false;
    filesCount = 0;
    importFiles: File[] = []; // импортируемые файлы
    queryParams: HttpParams = new HttpParams();
    noImportFlag = false;
    loaded = false;
    notPassMask: File[] = [];
    textToExport = '';
    importedSuccessfully: string[] = [];
    importedWithErrors: string[] = [];
    notImported: string[] = [];
    docsWarnings = new Map();

    constructor(private _activeModal: NgbActiveModal,
                private _iconsService: IconsService,
                protected fSaver: FileSaverService) {
    }

    ngOnInit(): void {
    }

    onClose(): void {
        this._activeModal.close(true);
        this.loading = false;
    }

    startImport(): void {
        this.inputFile.sendOnlyFormData(this.importFiles, this.url)
          .pipe(tap(() => this.inputFile.loader = true), catchError(err => {
              this.stopImportAfterAll();
              return of();
          })).subscribe((data) => {
            this.importedSuccessfully = [...this.importedSuccessfully, ...data.importedSuccessfully];
            this.importedWithErrors = [...this.importedWithErrors, ...data.importedWithErrors];
            this.notImported = [...this.notImported, ...data.notImported];
            this.importPercent = data.persent;
            this.stopImportAfterAll();
            this.textToExport += data.text;
        });
    }

    /**
     * Обработчик начала импорта
     */
    onSendStart(files: File[]): void {
        this.loaded = false;
        this.loading = true;
        this.filesCount = files.length;
        if (files.length > 0) {
            for (const item of files) {
                this.importFiles.push(item);
            }
        } else {
            //заканчиваем импорт
            setTimeout(() => {
                this.upploadingFiles = false;
                this.loading = false;
            }, 1000);
        }
    }

    /**
     * Обработчик конца импорта
     */
    onFinishImport(event?: []): void {
        if (event) {
            this.importedData.push(...event);
        }
    }

    /**
     * Получаем файлы првышающие размер
     */
    overSizeFiles(files) {
        this.overSizeFilesArr = [];
        this.overSizeFilesArr = files;
    }

    ngOnDestroy(): void {
        this.loading = false;
    }

    /**
     * Экспорт результатов импорта для общего файла или одного
     */
    exportImportResults(fileName?: string): void {
        let textForTxt = this.textToExport;
        if (fileName) {
            const regex = new RegExp(`(${fileName}[\\s\\S]*?)(?=\n\n)`, 'g');
            const matches = this.textToExport.match(regex);
            if (matches[0]) {
                textForTxt = matches[0];
            }
        }
        const blob = new Blob([textForTxt], {type: "text/plain"});
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = this.generateFileName(!fileName);
        link.click();
        link.remove();
    }

    /**
     * Генерация имени файла
     * @param isAll - параметр, в зависимости от которого будет выдаваться имя для всех документов или для одного
     */
    generateFileName(isAll: boolean = false): string {
        const date = moment();
        return isAll ? `all_import_${date.format("YYYYMMDD")}_${date.format("HHmm")}` :
          `document_import_${date.format("YYYYMMDD")}_${date.format("HHmm")}`;
    }

    /**
     * Нажатие "Выбрать файлы для импорта"
     * обнуляем результаты предыдущего импорта
     */
    getFiles() {
        this.overSizeFilesArr = [];
        this.upploadingFiles = true;
        this.importPercent = 0;
        this.filesCount = 0;
        this.importFiles = [];
        this.notPassMask = [];
        this.textToExport = '';
        this.importedWithErrors = [];
        this.notImported = [];
        this.importedSuccessfully = [];
        this.docsWarnings.clear();
    }

    /**
     * Кнопка Нет
     */
    noImport() {
        this.noImportFlag = true;
    }

    getDocWarning(docName: string) {
        return this.docsWarnings.get(docName);
    }

    /**
     * Перенёс из старого импорта
     */
    replaceMessage(msg): HTMLElement {
        return msg?.replaceAll(',\n-', ',<br />-')
          ?.replaceAll(':', ':<br />');
    }

    private stopImportAfterAll(): void {
        this.inputFile.loader = false;
        this.loading = false;
    }

    private filterTextExport(mapDocNames: Map<string, string>) {
        const arrayFromText = this.textToExport.split('\n\n').filter(fileName => {
            const endFileName = fileName.indexOf('\n');
            const docName = endFileName !== -1 ? fileName.substring(0, endFileName) : fileName;
            return !mapDocNames.get(docName);
        });
        this.textToExport = arrayFromText.join('\n\n');
    }
}
